export const INTERACT = {
  HCP_HOST: import.meta.env.VITE_INTERACT_HCP_HOST as string,
  TRANSLATION_S3_URL: import.meta.env.VITE_TRANSLATION_S3_URL as string,
};
